export default __webpack_public_path__ + "static/media/delivery.df59e5d3.svg";